module.exports = __webpack_public_path__ + "img/Email - dark.c1a832de.svg";